import en_US_messages from "@/i18n/en_US.json"

import {
  fromReactIntl, toReactIntl 
} from "@/util/formatLocale"
import {
  gql 
} from "@apollo/client"
import {
  useEffect, useMemo, useState 
} from "react"
import {
  IntlProvider 
} from "react-intl"

const messageMap = {
  en_US: en_US_messages,
}

const GET_LOCALE = gql`
    query getLocale {
        # eslint-disable-next-line @graphql-eslint/require-id-when-available
        storeConfig {
            store_code
            locale
        }
    }
`

const LocaleProvider = (props) => {
  const [messages, setMessages] = useState(null)
  // const { data } = useQuery(GET_LOCALE, {
  //     fetchPolicy: 'cache-and-network',
  //     nextFetchPolicy: 'cache-first',
  // })

  const {
    data 
  } = {
    "storeConfig": {
      "__typename": "StoreConfig",
      "store_code": process.env.NEXT_PUBLIC_STORE_VIEW_CODE,
      "locale": process.env.NEXT_PUBLIC_DEFAULT_LOCALE_2
    }
  }

  const language = useMemo(() => {
    return data && data.storeConfig.locale
      ? toReactIntl(data.storeConfig.locale)
      : process.env.DEFAULT_LOCALE
  }, [data])

  /**
     * At build time, `__fetchLocaleData__` is injected as a global. Depending on the environment, this global will be
     * either an ES module with a `default` property, or a plain CJS module.
     *
     */
  // const fetchLocale =
  //     'default' in __fetchLocaleData__
  //         ? __fetchLocaleData__.default
  //         : __fetchLocaleData__

  useEffect(() => {
    if (language) {
      const locale = fromReactIntl(language)

      // fetchLocale(locale)
      //     .then(data => {
      //         setMessages(data.default);
      //     })
      //     .catch(error => {
      //         console.error(
      //             `Unable to load translation file. \n${error}`
      //         );
      // });
      setMessages(messageMap[locale])
    }
  }, [language])

  const handleIntlError = (error) => {
    if (messages) {
      if (error.code === "MISSING_TRANSLATION") {
        // TODO:
        // console.warn('Missing translation', error.message)
        return
      }

      throw error
    }
  }

  return (
    <IntlProvider
      key={language}
      {...props}
      defaultLocale={process.env.DEFAULT_LOCALE}
      locale={language}
      messages={messages}
      onError={handleIntlError}
    />
  )
}

export default LocaleProvider
